import { render } from "./MenuManagement.vue?vue&type=template&id=7c295d67&scoped=true"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"

import "./MenuManagement.vue?vue&type=style&index=0&id=7c295d67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c295d67"]])

export default __exports__